<template>
    <el-table
        :data="signInTable"
        border
        class="performanceSignInTable"
        :height="320"
    >
        <el-table-column
            label="商品编码"
            prop="itemCode"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品名称"
            prop="itemName"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="商品数量"
            prop="planQty"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="网点签收正品"
            prop="netRealReceive"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="网点签收短少"
            prop="netStockoutCount"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="终端签收正品"
            prop="finalRealReceive"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="终端签收霉变"
            prop="finalMildewPollute"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="终端签收破损"
            prop="finalPackageDamaged"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="终端签收拒收"
            prop="finalRejectQty"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
        <el-table-column
            label="终端签收短少"
            prop="finalStockoutCount"
            show-overflow-tooltip
            width="180px"
            align="center"
        ></el-table-column>
    </el-table>
</template>
<script>
export default {
    name: 'signInTable',
    data () {
        return {
            signInTable: []
        };
    },
    methods: {
        /**
         * @description 初始化用户签收表格数据
         * @param {Object} data 接口返回的用户表格数据
         */
        initTableData (data) {
            this.signInTable = data;
        }
    }
};
</script>
